import { FiRefreshCw } from 'react-icons/fi';
import React, { FC, ReactNode } from 'react';

const btnPrimaryStyles = `
text-md-semibold text-white
bg-primary-500
border-solid border border-primary-500
button-shadow
rounded-3xl
hover:ring-4 hover:ring-primary-300/20 hover:ring-offset-surface-base hover:shadow-sm transition-all duration-200 ease-in-out
disabled:bg-neutral-400 disabled:border-neutral-400 disabled:hover:ring-0 disabled:hover:ring-offset-0 disabled:hover:shadow-none disabled:pointer-events-none
`;
const btnSecondaryStyles = `
text-md-semibold text-text-primary
bg-surface-base
border-solid border border-gradient-brand
button-shadow
rounded-3xl
hover:ring-4 hover:ring-secondary-300/20 hover:ring-offset-surface-base hover:shadow-sm
transition-all duration-200 ease-in-out
disabled:text-neutral-400 disabled:hover:ring-0 disabled:hover:ring-offset-0 disabled:hover:shadow-none disabled:pointer-events-none
`;
const btnTertiaryStyles = `
text-md-semibold text-primary-500
bg-transparent
border-none rounded-3xl
shadow-none
hover:border-none hover:bg-primary-500/20 hover:shadow-none
focus:text-primary-500 focus:border-none focus:bg-primary-500/40 focus:shadow-none
disabled:text-neutral-400 disabled:border-none disabled:bg-transparent disabled:shadow-none
`;
const btnDangerStyles = `
text-md-semibold text-text-inverse
bg-error-600
border-solid border border-error-600
button-shadow
rounded-3xl
hover:bg-error-700 hover:border-error-700
disabled:bg-neutral-400 disabled:border-neutral-400
`;
const btnPageStyles = `
text-sm-regular text-text-primary
rounded-3xl
hover:ring-4 hover:ring-secondary-300/20 hover:ring-offset-surface-base hover:shadow-sm
transition-all duration-200 ease-in-out
disabled:text-neutral-400 disabled:hover:ring-0 disabled:hover:ring-offset-0 disabled:hover:shadow-none disabled:pointer-events-none
`;
const md = 'py-2.5 px-4 h-11';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  disabled?: boolean;
  size?: string;
  type?: 'button' | 'submit' | 'reset' | undefined;
  variant?: 'primary' | 'secondary' | 'tertiary' | 'danger' | 'page';
  loading?: boolean;
  isSelect?: boolean
  icon?: React.ReactNode;
}
const getStyleBtn = (variant: string) => {
  switch (variant) {
    case 'primary':
      return btnPrimaryStyles;
    case 'secondary':
      return btnSecondaryStyles;
    case 'tertiary':
      return btnTertiaryStyles;
    case 'danger':
      return btnDangerStyles;
    case 'page':
      return btnPageStyles;
    default:
      return btnPrimaryStyles;
  }
};

const getPaddingBtn = (size: string | undefined) => {
  switch (size) {
    case 'md':
      return md;
    default:
      return md;
  }
};
const Button: FC<ButtonProps> = ({
  children,
  disabled = false, size = 'md', type = 'button', variant = 'primary',
  loading,
  isSelect,
  icon,
  ...rest
}) => {
  const btnStyle = getStyleBtn(variant);
  const btnPadding = getPaddingBtn(size);

  return (
    <button {...rest} disabled={loading || disabled} type={type} className={
      `cursor-pointer normal-case w-full flex items-center justify-center
      ${btnPadding}
      ${btnStyle}
      ${btnStyle === btnPageStyles && isSelect ? 'border-solid border border-gradient-brand button-shadow rounded-3xl' : ''}
      `}>
      {loading
        && <FiRefreshCw className='animate-spin' />
      }
      {icon && <div className='flex items-center mr-2'>{!loading && icon}</div>}
      <span className={`${loading ? 'ml-2' : ''}`}>{children}</span>
    </button>
  );
};

export default Button;
